import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatRadioModule } from '@angular/material/radio';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { MatListModule } from '@angular/material/list';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatTableModule } from '@angular/material/table';
import { MatPaginatorModule } from '@angular/material/paginator';
import { MatMenuModule } from '@angular/material/menu';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatBadgeModule } from '@angular/material/badge';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { RouterModule } from '@angular/router';
import { ConfirmDialogComponent } from './shared/components/confirm-dialog/confirm-dialog.component';
import { ShippingCardComponent } from './shared/components/shipping-card/shipping-card.component';
import { SidebarComponent } from './shared/components/sidebar/sidebar.component';
import { ItemSideBarComponent } from './shared/components/item-side-bar/item-side-bar.component';
import { DataTableComponent } from './shared/components/data-table/data-table.component';
import { SideBarService } from './shared/service/side-bar.service';
import { HelpModalComponent } from './shared/components/help-modal/help-modal.component';
import { FormTableComponent } from './shared/components/form-table/form-table.component';
import { LoaderComponent } from './shared/components/loader/loader.component';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatNativeDateModule } from '@angular/material/core';

const components: any[] = [
	ShippingCardComponent,
	ConfirmDialogComponent,
	SidebarComponent,
	ItemSideBarComponent,
	DataTableComponent,
	HelpModalComponent,
	FormTableComponent,
	LoaderComponent,
];
@NgModule({
	imports: [
		CommonModule,
		RouterModule,

		// Angular Material
		MatButtonModule,
		MatCardModule,
		MatFormFieldModule,
		MatIconModule,
		MatInputModule,
		MatRadioModule,
		MatSnackBarModule,
		MatButtonModule,
		MatCardModule,
		MatIconModule,
		MatRadioModule,
		MatListModule,
		MatExpansionModule,
		MatTableModule,
		MatPaginatorModule,
		MatMenuModule,
		MatCheckboxModule,
		MatBadgeModule,
		MatProgressSpinnerModule,
		MatNativeDateModule,
		MatDatepickerModule,
		FormsModule,
		ReactiveFormsModule,
	],
	providers: [SideBarService],
	declarations: [components],
	exports: [components],
})
export class SharedModule {}
